import type { User } from '../types/auth';

export function isContactVerified(user: User): boolean {
  if (user.emailVerifiedAt || user.phoneVerifiedAt) return true;
  return !user.contactVerificationRequired;
}

export function mustVerifyContact(user: User): boolean {
  return Boolean(user.contactVerificationRequired) && !user.emailVerifiedAt && !user.phoneVerifiedAt;
}
